/**
 * Viewport-fixed host for the add-to-cart dialog on /pages/custom.
 * Content is serialized from the iframe — same DOM after prepareHoloCartUpsellOfferV1Dialog.
 */
(function () {
  const CUSTOM_PATH = "/pages/custom";

  function isOnCustomPage() {
    const path = (window.location.pathname.replace(/\/+$/, "") || "/").toLowerCase();
    return path === CUSTOM_PATH || path.endsWith(CUSTOM_PATH);
  }

  if (!isOnCustomPage()) return;

  const host = document.getElementById("holo-cart-added-host");
  const dialog = document.getElementById("cart-added-dialog");
  const backdrop = host?.querySelector("[data-holo-cart-added-backdrop]");

  function resolveHoloOrigin() {
    const embed = document.querySelector("[data-holo-creator]");
    const fromData = embed?.getAttribute("data-holo-origin");
    if (fromData) {
      try {
        return new URL(fromData, window.location.origin).origin;
      } catch {
        /* ignore */
      }
    }
    const iframe = document.querySelector("[data-holo-creator] iframe, .spark-stack-holo-frame");
    if (iframe?.src) {
      try {
        return new URL(iframe.src, window.location.origin).origin;
      } catch {
        /* ignore */
      }
    }
    return "";
  }

  function postToIframe(message) {
    if (window.HoloCommerceBridge?.postToIframe) {
      window.HoloCommerceBridge.postToIframe(message);
      return;
    }
    const iframe = document.querySelector("[data-holo-creator] iframe, .spark-stack-holo-frame");
    const origin = resolveHoloOrigin();
    if (!iframe?.contentWindow || !origin) return;
    try {
      iframe.contentWindow.postMessage(message, origin);
    } catch {
      /* ignore */
    }
  }

  function isTrustedHoloMessage(event) {
    const origin = resolveHoloOrigin();
    if (origin && event.origin !== origin) return false;
    return Boolean(event.data && event.data.source === "sparkstack-holo");
  }

  function supportsPopover() {
    return Boolean(host && typeof host.showPopover === "function");
  }

  function mountHost() {
    if (!host || host.parentElement === document.body) return;
    document.body.appendChild(host);
  }

  function applySerializedDialog(payload) {
    if (!dialog || !payload) return;
    dialog.className = String(payload.className || "cart-added-dialog");
    dialog.classList.add("cart-added-dialog--host-open");
    dialog.innerHTML = String(payload.innerHTML || "");
  }

  function showHost(payload) {
    if (!host || !dialog) return;
    mountHost();
    applySerializedDialog(payload);

    let shownInTopLayer = false;
    if (supportsPopover()) {
      try {
        if (!host.matches(":popover-open")) host.showPopover();
        shownInTopLayer = true;
      } catch {
        shownInTopLayer = false;
      }
    }

    host.classList.toggle("holo-cart-added-host--legacy-open", !shownInTopLayer);
    host.hidden = false;
    document.body.classList.add("holo-cart-added-open");
    dialog.querySelector("#cart-added-another, .cart-added-another")?.focus();
  }

  function hideHost() {
    if (!host) return;
    if (supportsPopover() && host.matches(":popover-open")) {
      try {
        host.hidePopover();
      } catch {
        /* ignore */
      }
    }
    host.classList.remove("holo-cart-added-host--legacy-open");
    host.hidden = true;
    document.body.classList.remove("holo-cart-added-open");
  }

  function sendAction(action) {
    hideHost();
    postToIframe({
      type: "HOLO_CART_ADDED_DIALOG_ACTION",
      action,
      source: "sparkstack-holo-theme",
    });
  }

  mountHost();

  host?.addEventListener("click", (event) => {
    const another = event.target.closest("#cart-added-another, .cart-added-another");
    const checkout = event.target.closest("#cart-added-checkout, .cart-added-checkout");
    if (another) {
      event.preventDefault();
      sendAction("another");
      return;
    }
    if (checkout) {
      event.preventDefault();
      sendAction("checkout");
    }
  });

  window.addEventListener("message", (event) => {
    if (!isTrustedHoloMessage(event)) return;
    const data = event.data;
    if (data.type !== "HOLO_CART_ADDED_DIALOG") return;
    if (data.action === "hide") {
      hideHost();
      return;
    }
    if (data.action === "show" && data.dialog) {
      showHost(data.dialog);
    }
  });

  host?.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    event.preventDefault();
  });
})();
